export default __webpack_public_path__ + "static/media/3643_123816.e0731a9f.svg";